export const ACCESS_TOKEN_EXPIRED_TIME = "ACCESS_TOKEN_EXPIRED_TIME";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const IS_AUTEHNTICATED = "IS_AUTEHNTICATED";
export const USER_TYPE = "USER_TYPE";
export const SUBSCRIPTION_ID = "SUBSCRIPTION_ID";
export const CART_ITEMS = "CART_ITEMS";
export const SIGNUP_FORM = "SIGNUP_FORM";
